import React from "react"
import styled from "styled-components"
import { observer } from "mobx-react"

import ToggleSwitch from "../Checkout/ToggleSwitch"
import useInject from "~/hooks/useInject"

const NotificationToggleContainer = styled.div`
  display: inline-flex;
  min-width: 250px;
  flex: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background-color: ${(props) => props.theme.colors.background.main};
  border-radius: 0px 0px 4px 4px;
  padding: 1em;
  padding-top: 1.25em;
  padding-bottom: 1.25em;
  ${(props) => props.theme.media.mobile`
    min-width: 0;
  `}
`

const ToggleDescription = styled.label`
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  color: ${(props) => props.theme.colors.text.label};
  padding-left: 0.75em;
  cursor: pointer;
  small {
    display: block;
    font-size: 0.9em;
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }
`

const mapStore = (store) => ({
  plate: store.parkingFlow.flow.plate,
})

const CommunicationsToggle = () => {
  const { plate } = useInject(mapStore)
  if (!plate) return null
  return (
    <NotificationToggleContainer>
      <ToggleSwitch
        id="set-notification-for-plates"
        handleSwitch={plate.togglePlateNotification}
        switchStatus={plate.plateNotifications}
      />
      <ToggleDescription htmlFor="set-notification-for-plates">
        Get notified about future tickets
        <small>
          New tickets issued to {plate.plateNumber}
          {plate.state && ` (${plate.state})`}
        </small>
      </ToggleDescription>
    </NotificationToggleContainer>
  )
}

export default observer(CommunicationsToggle)
